import { publishDescription } from './PublishStore';

export const updatePublishDescription = (value) => publishDescription.update((oldValue) => value);
